import { useState } from 'react';
import { Box, styled } from '@mui/material';
import { Handle, type Node, type NodeProps, Position } from '@xyflow/react';
import { ExpandButton } from './expand-button';
import { OrBlockViewer } from './or-block-viewer';
import { NodeHeader } from '../node-header';
import type { EnrollNodeData } from '../../../../components/workflow-editor/mappers/map-canvas-content.types';

const COLLAPSED_MAX_HEIGHT = 250;

export const EnrollNode = ({ data }: NodeProps<Node<EnrollNodeData, 'enroll'>>) => {
  const orBlocks = data.orBlocks ?? [];
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <NodeWrapper expanded={isExpanded} className="nopan" data-testid="enroll-node">
      <NodeHeader nodeTitle="Enroll" />
      <Description>
        {orBlocks.length === 0
          ? 'Configure this node to start enrolling shifts that fit the requirements. '
          : 'Enrolling shifts that fit the following requirements:'}
      </Description>

      <OrBlockViewer orBlocks={orBlocks} isExpanded={isExpanded} />

      <ExpandButton
        expanded={isExpanded}
        onClick={() => setIsExpanded((prev) => !prev)}
        display={orBlocks.length > 1}
      />

      <Handle type="source" position={Position.Right} />
    </NodeWrapper>
  );
};

const NodeWrapper = styled(Box)<{ expanded: boolean }>(({ theme, expanded }) => ({
  position: 'relative',
  backgroundColor: 'white',
  border: `1px solid ${theme.palette.lwSecondaryAccentLight[20]}`,
  borderRadius: theme.spacing(3),
  padding: theme.spacing(2),
  maxWidth: 320,
  transition: 'max-height 200ms ease',
  maxHeight: expanded ? 'none' : COLLAPSED_MAX_HEIGHT,
  overflow: expanded ? 'visible' : 'hidden',
}));

const Description = styled(Box)(({ theme }) => ({
  fontSize: '10px',
  textAlign: 'justify',
  paddingBottom: theme.spacing(2),
}));
